import { Injectable } from '@angular/core';
import { Link } from '../models/link';
import { HttpClient } from '@angular/common/http';
import { HandleError } from './service-helper';
import { EMPTY, Observable } from 'rxjs';

@Injectable()
export class LinkService {
  private linkUrl = 'api/links';

  constructor(private http: HttpClient) { }

  get(): Observable<Link[]> {
     return EMPTY; 
  }

  insert(link: Link): Promise<Link> {
    return this.http.post(this.linkUrl, link)
      .toPromise()
      .catch(HandleError);
  }

  update(link: Link): Promise<void> {
    return this.http.put(`${this.linkUrl}/${link.id}`, link)
      .toPromise()
      .catch(HandleError);
  }

  remove(id: number): Promise<void> {
    return this.http.delete(`${this.linkUrl}/${id}`)
      .toPromise()
      .catch(HandleError);
  }
}